import { render, staticRenderFns } from "./rank-list.vue?vue&type=template&id=2ad4b34a&scoped=true"
import script from "./rank-list.vue?vue&type=script&lang=js"
export * from "./rank-list.vue?vue&type=script&lang=js"
import style0 from "./rank-list.vue?vue&type=style&index=0&id=2ad4b34a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad4b34a",
  null
  
)

export default component.exports